export default __webpack_public_path__ + "static/grapeseed_bunker-00603e616beaed67ef497d8b27ccc05e.png";